module.exports = __webpack_public_path__ + "media/images/screen_federation-2e3d2e6a976a77293e341b6188515bf2.svg";